import React, { useEffect, useState, useRef } from 'react'
import '.././App.css';
import Swal from 'sweetalert2';
import { auth, db } from '../firebase';
import { collection, addDoc, Timestamp, query, orderBy, onSnapshot, getDoc, getDocs, deleteDoc, doc, setDoc } from 'firebase/firestore'

export default function ProductUnit() {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  });
  const [userData, setUserData] = useState();
  const [productUnitData, setproductUnitData] = useState([]);
  const [searchText, setsearchText] = useState("");
  const [unit, setunit] = useState("");

  const [updocid, setupdocid] = useState("");
  const [upunit, setupunit] = useState("");

  useEffect(() => {
    if (searchText == '') {
      fetchData1()
    } else {
      fetchData2()
    }
  }, [searchText]);



  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setUserData(user);
    });
  });

  const fetchData1 = async () => {
    try {
      const q = query(collection(db, 'productunits'), orderBy("created","asc"))
      onSnapshot(q, (querySnapshot) => {
        setproductUnitData(querySnapshot.docs.map(doc => ({
          id: doc.id,
          data: doc.data()
        })));
      });
    } catch (error) {
      Toast.fire({
        icon: "error",
        title: error.message
      });
    }
  }

  const fetchData2 = async () => {
    try {
      const filteredData = productUnitData.filter((item) =>
        item.data.unit.toUpperCase().includes(searchText.toUpperCase())
      );
      setproductUnitData(filteredData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }



  const handleSubmit = async () => {
    await addDoc(collection(db, 'productunits'), {
      unit: unit,
      uid: userData.uid,
      created: Timestamp.now()
    });
    setunit(""); 
    Toast.fire({
      icon: "success",
      title: 'Product Unit Added Successfully!!'
    });
  }

  const handleDelete = async (docid) => {
    console.log(docid);
    const taskDocRef = doc(db, 'productunits', docid)
    await deleteDoc(taskDocRef)
    Toast.fire({
      icon: "success",
      title: 'Product Unit Deleted Successfully!!'
    });
    fetchData1();
  }

  const handleEdit = (docid, unit) => {
    setupdocid(docid);
    setupunit(unit);
  }

  const handleUpdate = async () => {
    await setDoc(doc(db, "productunits", updocid), {
      unit: upunit,
      uid: userData.uid,
      created: Timestamp.now()
    });
    Toast.fire({
      icon: "success",
      title: 'Product Unit Updated Successfully!!'
    });

    fetchData1();
  }

  return (
    <div>
      <div className="content-wrapper">
        <br />
        <section className="content">
          <div className="container-fluid">
            <button className="btn btn-secondary " style={{ float: "right" }} >|| Product Unit ||</button><br /><br />
            <button className="btn btn-info btn-sm" data-toggle="modal" data-target="#insert-modal">Add Product Unit</button>
            <div className="card card-primary card-outline ex1">
              <div className=" p-1">
                &nbsp;&nbsp;<input type="search" value={searchText} onChange={(e) => setsearchText(e.target.value)}
                  className='form-control col-sm-4' placeholder='Type here......' />&nbsp;
              </div>
              <div className="card-body table-responsive p-0" >
                <table className="table table-bordered table-hover table-striped table-head-fixed">
                  <thead>
                    <tr>
                      <th>Sr No</th>
                      <th>Product Unit</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      productUnitData.map((item, num = 1) =>
                        <tr key={num + 1}>
                          <td width="80">{num + 1}</td>
                          <td>{item.data.unit}</td>
                          <td>
                            <a onClick={() => handleEdit(item.id, item.data.unit)} href='#0' data-toggle="modal" data-target="#text-modal1" className="btn btn-sm btn-success" > <i className="fa fa-edit"></i></a>&nbsp;
                            <a onClick={() => { if (window.confirm('Are u sure?')) { handleDelete(item.id) }; }} className="btn btn-sm btn-danger" href='#0' > <i className="fa fa-trash"></i></a>
                          </td>
                        </tr>
                      )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* ============================================= modal start ================================================= */}

      <div className="modal fade" id="insert-modal">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Product Unit</h4>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-sm-6">
                  <label>  Product Unit</label>
                  <input type="text" value={unit} onChange={(e) => setunit(e.target.value)} className="form-control" />
                </div>
              </div><br />
            </div>
            <div className="modal-footer justify-content-between">
              <button type="button" onClick={() => handleSubmit()} className="btn btn-primary" data-dismiss="modal">Save </button>
              <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>


      <div className="modal fade" id="text-modal1">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit Product Unit</h4>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-sm-6">
                  <label> Product Unit</label>
                  <input type="text" value={upunit} onChange={(e) => setupunit(e.target.value)} className="form-control" placeholder="Enter  Item Name ..." />
                </div>
              </div><br />
            </div>
            <div className="modal-footer justify-content-between">
              <button type="button" onClick={() => handleUpdate()} className="btn btn-primary" data-dismiss="modal">Update </button>
              <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
